/*
 * @Author: Teemo Ding
 * @Date: 2021-09-28 13:44:52
 * @LastEditTime: 2022-06-13 17:58:01
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogistics/Components/AvailableClickAndCollectTime.tsx
 */
import {
  DatePicker,
  NumberInput,
  RadioGroup,
  RadioItem,
  Select,
} from '@/src/components/Antd';
import InputWithTextInForm from '@/src/components/Antd/NumberInput/InputWithTextInForm';
import { Form } from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { Fragment } from 'react';
import styles from '../style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

export enum AvailableTimeType {
  SpecificDays = 'SpecificDays',
  UponNotification = 'UponNotification',
  Immediately = 'Immediately',
  BeforeDate = 'BeforeDate',
}

export enum AfterPaymentCompleteType {
  AfterPaymentComplete = 'AfterPaymentComplete',
  AfterReadyToCollectNotification = 'AfterReadyToCollectNotification',
}

const disabledDate = (current, add: number) => {
  // Can not select days before today and today

  const disabledInd = -1 + Number(add);
  return current && current < moment().add(disabledInd, 'days');
};

const handleSpecificDaysChange = (form) => {
  form.validateFields([['pickupAvailableTime', 'till', 'beforeDate']]);
};

const AvailableClickAndCollectTime = ({ form, disableEdit }: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const AfterPaymentCompleteList = {
    [AfterPaymentCompleteType.AfterPaymentComplete]: getI18n(
      'salesChannelLogistics.index.afterpaymentcomplete',
    ),
    [AfterPaymentCompleteType.AfterReadyToCollectNotification]: getI18n(
      'salesChannelLogistics.index.afterreadytocollectnotification',
    ),
  };
  return (
    <Fragment>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) => {
          return (
            get(prevValues, 'pickupAvailableTime.from.type', '') !==
              get(curValues, 'pickupAvailableTime.from.type', '') ||
            get(prevValues, 'pickupAvailableTime.till.type', '') !==
              get(curValues, 'pickupAvailableTime.till.type', '') ||
            get(prevValues, 'pickupAvailableTime.from.specificDays', '') !==
              get(curValues, 'pickupAvailableTime.from.specificDays', '')
          );
        }}>
        {({ getFieldValue }: any) => (
          <Fragment>
            <Form.Item
              labelCol={{ span: 24 }}
              name={['pickupAvailableTime', 'from', 'type']}
              initialValue={AvailableTimeType.SpecificDays}
              className={styles.pickupAvailableTimeFrom}
              rules={[
                {
                  required: true,
                  message: replaceI18nVariables(
                    getI18n('general.fieldisrequired'),
                    getI18n('salesChannelLogistics.index.pickupAvailableFrom'),
                  ),
                },
              ]}
              label={getI18n(
                'salesChannelLogistics.index.pickupAvailableFrom',
              )}>
              <RadioGroup className={styles.radioGroup} disabled={disableEdit}>
                <div className={styles.radioItem}>
                  <RadioItem value={AvailableTimeType.SpecificDays}>
                    {getI18n('salesChannelLogistics.index.specificdays')}
                  </RadioItem>

                  {getFieldValue(['pickupAvailableTime', 'from', 'type']) ==
                    AvailableTimeType.SpecificDays && (
                    <Form.Item
                      name={['pickupAvailableTime', 'from', 'specificDays']}
                      className={styles.specificDays}
                      rules={[
                        {
                          required: true,
                          message: replaceI18nVariables(
                            getI18n('general.fieldisrequired'),
                            getI18n('salesChannelLogistics.index.specificdays'),
                          ),
                        },
                      ]}>
                      <InputWithTextInForm
                        disabled={disableEdit}
                        size='large'
                        min={1}
                        suffix={getI18n('salesChannelLogistics.index.days')}
                        onChange={() => handleSpecificDaysChange(form)}
                        text={getI18n(
                          'salesChannelLogistics.index.afterpaymentcomplete',
                        )}
                      />
                    </Form.Item>
                  )}
                </div>
                <div className={styles.radioItem}>
                  <RadioItem
                    disabled={false}
                    value={AvailableTimeType.UponNotification}>
                    {getI18n(
                      'salesChannelLogistics.index.readytocollectionnotification',
                    )}
                  </RadioItem>
                </div>
                <div className={styles.radioItem}>
                  <RadioItem
                    disabled={false}
                    value={AvailableTimeType.Immediately}>
                    {getI18n('salesChannelLogistics.index.immediately')}
                  </RadioItem>
                </div>
              </RadioGroup>
            </Form.Item>
            <Form.Item
              name={['pickupAvailableTime', 'till', 'type']}
              label={getI18n('salesChannelLogistics.index.pickupAvailableTill')}
              initialValue={AvailableTimeType.SpecificDays}
              className={styles.pickupAvailableTimeTill}
              labelCol={{ span: 24 }}>
              <RadioGroup className={styles.radioGroup} disabled={disableEdit}>
                <div className={styles.radioItem}>
                  <RadioItem value={AvailableTimeType.SpecificDays}>
                    {getI18n('salesChannelLogistics.index.specificdays')}
                  </RadioItem>
                  {(getFieldValue(['pickupAvailableTime', 'from', 'type']) ==
                    AvailableTimeType.SpecificDays ||
                    getFieldValue(['pickupAvailableTime', 'from', 'type']) ==
                      AvailableTimeType.Immediately) &&
                    getFieldValue(['pickupAvailableTime', 'till', 'type']) ==
                      AvailableTimeType.SpecificDays && (
                      <Form.Item
                        className={styles.specificDays}
                        rules={[
                          {
                            required: true,
                            message: replaceI18nVariables(
                              getI18n('general.fieldisrequired'),
                              getI18n(
                                'salesChannelLogistics.index.specificdays',
                              ),
                            ),
                          },
                          {
                            type: 'number',
                            min: getFieldValue([
                              'pickupAvailableTime',
                              'from',
                              'specificDays',
                            ]),
                            message: getI18n(
                              'salesChannelLogistics.index.invalidSpecificDayssetting',
                            ),
                          },
                        ]}
                        name={['pickupAvailableTime', 'till', 'specificDays']}>
                        <InputWithTextInForm
                          size='large'
                          suffix={getI18n('salesChannelLogistics.index.days')}
                          text={getI18n(
                            'salesChannelLogistics.index.afterpaymentcomplete',
                          )}
                          disabled={disableEdit}
                        />
                      </Form.Item>
                    )}
                  {getFieldValue(['pickupAvailableTime', 'from', 'type']) ==
                    AvailableTimeType.UponNotification &&
                    getFieldValue(['pickupAvailableTime', 'till', 'type']) ==
                      AvailableTimeType.SpecificDays && (
                      <div className={styles.pickupAvailableTimeTill}>
                        <Form.Item
                          name={['pickupAvailableTime', 'till', 'specificDays']}
                          rules={[
                            {
                              required: true,
                              message: replaceI18nVariables(
                                getI18n('general.fieldisrequired'),
                                getI18n(
                                  'salesChannelLogistics.index.specificdays',
                                ),
                              ),
                            },
                          ]}>
                          <NumberInput
                            className={styles.input}
                            size='large'
                            suffix={getI18n('salesChannelLogistics.index.days')}
                            disabled={disableEdit}
                          />
                        </Form.Item>
                        <Form.Item
                          name={['pickupAvailableTime', 'till', 'specificType']}
                          initialValue={
                            AfterPaymentCompleteType.AfterPaymentComplete
                          }>
                          <Select
                            size='large'
                            disabled={disableEdit}
                            className={styles.specificType}
                            optionsList={Object.entries(
                              AfterPaymentCompleteList,
                            ).map((item) => ({
                              value: item[0],
                              label: item[1],
                            }))}
                          />
                        </Form.Item>
                      </div>
                    )}
                </div>
                <div className={styles.radioItem}>
                  <RadioItem
                    disabled={false}
                    value={AvailableTimeType.BeforeDate}>
                    {getI18n('salesChannelLogistics.index.pickupbefore')}
                  </RadioItem>
                  {getFieldValue(['pickupAvailableTime', 'till', 'type']) ==
                    AvailableTimeType.BeforeDate && (
                    <Form.Item
                      name={['pickupAvailableTime', 'till', 'beforeDate']}
                      className={styles.beforeDates}
                      rules={[
                        {
                          required: true,
                          message: replaceI18nVariables(
                            getI18n('general.fieldisrequired'),
                            getI18n('salesChannelLogistics.index.pickupbefore'),
                          ),
                        },
                        {
                          validator(_, value) {
                            if (
                              disabledDate(
                                value,
                                getFieldValue([
                                  'pickupAvailableTime',
                                  'from',
                                  'specificDays',
                                ]),
                              )
                            ) {
                              return Promise.reject(
                                new Error(
                                  getI18n(
                                    'salesChannelLogistics.index.invalidtimesetting',
                                  ),
                                ),
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}>
                      <DatePicker
                        disabled={disableEdit}
                        format='YYYY-MM-DD'
                        disabledDate={(current) =>
                          disabledDate(
                            current,
                            getFieldValue([
                              'pickupAvailableTime',
                              'from',
                              'specificDays',
                            ]) || 0,
                          )
                        }
                        size='large'
                      />
                    </Form.Item>
                  )}
                </div>
              </RadioGroup>
            </Form.Item>
          </Fragment>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default AvailableClickAndCollectTime;
